export const DEFAULT_BUSINESS_UNIT_ID = 0;
export const ALL_BUSINESS_UNIT_ID = 'ALL';
export const SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY = 'SELECTED_BUSINESS_UNIT';
export const BUSINESS_UNIT_URL_PARAM = 'businessUnitId';